import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const QuickAccessActions = createActionGroup({
	source: 'Quick Access',
	events: {
		'Loaded': props<{
			pinnedJobs: string[];
			recentJobs: string[];
			jobsWithUnsavedChanges: string[];
		}>(),
		'Job Clicked ': props<{
			jobId: string;
			method: 'details' | 'current tab' | 'new tab',
		}>(),
		'Job Pinned ': props<{ jobId: string }>(),
		'Toogle Quick Access ': emptyProps(),
	},
});
